<template>
    <div>
        <vue-scroll :ops="$ops" :style="{'height':$parentInfo.clientHeight-156+'px'}" >
            <div class="table-responsive" style="clear: both;">
                <table class="table table-bordered">
                <tbody width='100%'>
                    <tr>
                        <td width='10%'>
                            <div>基本信息</div>
                        </td>
                        <td colspan="3" width='90%'>
                            <div>学校：{{$parentInfo.renewDetail.school_name}}</div>
                            <div>年级：{{$parentInfo.renewDetail.grade_name}}</div>
                            <div>电话号码：{{$parentInfo.renewDetail.phone}}</div>
                            <div>家长信息： <a v-for="parent in $parentInfo.renewDetail.parents">{{parent.name}}:{{parent.phone}},</a></div>
                            <div>在读科目及老师：
                                <span v-for="student_subject in $parentInfo.renewDetail.student_subjects">
                                {{student_subject.subject_name}}-{{student_subject.employees_name}}-{{student_subject.week_name}}；
                            </span>
                            </div>
                            <div style="text-align: right">
                                <el-button @click="handleStudentDetail">进入详情</el-button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td width='10%'>状态</td>
                        <td colspan="3" width='90%'>
                            <el-select v-model="$parentInfo.renewDetail.status" filterable remote @change="handleRealTimeSave()">
                                <el-option
                                        v-for="item in status_array"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td width='10%'>任务完成勾选</td>
                        <td colspan="3" width='90%'>
                            <el-checkbox-group v-model="$parentInfo.renewDetail.task_ids" @change="handleRealTimeSave()">
                                <el-checkbox-button v-for="task in tasks" :label="task.id" :key="task.id">{{task.name}}</el-checkbox-button>
                            </el-checkbox-group>
                        </td>
                    </tr>
                    <tr>
                        <td width='10%'>在读学科</td>
                        <td colspan="3" width='90%'>
                            <a style="padding-right: 10px" v-for="activeSubject in $parentInfo.renewDetail.activeSubjects">
                                <el-button round :style="{'background-color':activeSubject.view===1?'#65ff34':'white'}">{{activeSubject.name}}</el-button>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td width='10%'>推荐学科</td>
                        <td colspan="3" width='90%'>
                            <a style="padding-right: 10px" v-for="recommendSubject in $parentInfo.renewDetail.recommendSubjects">
                                <el-button round :style="{'background-color':recommendSubject.view===1?'#00BFFF':'white'}" @click="handleRecommend(recommendSubject.id)">{{recommendSubject.name}}</el-button>
                            </a>
                        </td>
                    </tr>
                    <tr v-for="activeRenew in $parentInfo.renewDetail.activeRenew" >
                        <td width='10%'>{{activeRenew.subject_name}}</td>
                        <td width='30%'>
                            <div>
                                <el-radio-group v-model="activeRenew.attitude.id"  @change="handleRealTimeSave()">
                                    <el-radio-button label="1">满意</el-radio-button>
                                    <el-radio-button label="2">不满意</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div v-if="activeRenew.attitude.id">
                                <el-input v-model="activeRenew.attitude.remark"
                                          type="textarea"
                                          :rows="2"
                                          @blur="handleRealTimeSave"
                                          placeholder="请输入内容">
                                </el-input>
                            </div>
                        </td>
                        <td width='30%'>
                            <div>
                                <el-radio-group v-model="activeRenew.continueClass.id"  @change="handleActive(activeRenew.subject_id,activeRenew.continueClass.id)">
                                    <el-radio-button label="1">续班</el-radio-button>
                                    <el-radio-button label="2">不续班</el-radio-button>
                                    <el-radio-button label="3">不连报</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div v-if="activeRenew.continueClass.id==='2'">
                                <div>
                                    <el-select v-model="activeRenew.continueClass.cancelReason_id" placeholder="请选择不续班原因" @change="handleRealTimeSave()">
                                        <el-option
                                                v-for="item in notContinueClassReasons"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-if="activeRenew.continueClass.cancelReason_id==2">
                                    <el-select v-model="activeRenew.continueClass.otherReason_id" placeholder="请选择不想补原因" @change="handleRealTimeSave()">
                                        <el-option
                                                v-for="item in continueClass_otherReason"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-if="activeRenew.continueClass.cancelReason_id!=2">
                                    <el-input v-model="activeRenew.continueClass.remark"
                                              type="textarea"
                                              :rows="2"
                                              @blur="handleRealTimeSave"
                                              :placeholder="keyNotContinueClassReasons[activeRenew.continueClass.cancelReason_id].remark">
                                    </el-input>
                                </div>
                                <div v-else-if="activeRenew.continueClass.cancelReason_id==2">
                                    <el-input v-model="activeRenew.continueClass.remark"
                                              type="textarea"
                                              :rows="2"
                                              @blur="handleRealTimeSave"
                                              :placeholder="keyContinueClass_otherReason[activeRenew.continueClass.otherReason_id].remark">
                                    </el-input>
                                </div>
                                <div v-if="activeRenew.continueClass.cancelReason_id==1">
                                    <el-input v-model="activeRenew.continueClass.remark2"
                                              type="textarea"
                                              :rows="2"
                                              @blur="handleRealTimeSave"
                                              :placeholder="keyNotContinueClassReasons[1].remark2">
                                    </el-input>
                                </div>
                            </div>
                            <div v-else-if="activeRenew.continueClass.id==='3'">
                                <el-input v-model="activeRenew.continueClass.remark"
                                          type="textarea"
                                          :rows="2"
                                          @blur="handleRealTimeSave"
                                          placeholder="请输入不连报原因">
                                </el-input>
                            </div>
                        </td>
                        <td width='30%'>
                            <div style="display: flex;flex-direction: row;justify-content:space-around ">
                                <div >
                                    <div>
                                        <el-select v-model="activeRenew.conclusion.subsequent_id" placeholder="请选择后续操作" clearable multiple @change="handleRealTimeSave()">
                                            <el-option
                                                    v-for="item in subsequent_choose"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <br>
                                    <div>
                                        <el-radio-group v-model="activeRenew.conclusion.resolve_id" @change="handleActive(activeRenew.subject_id,activeRenew.conclusion.resolve_id)">
                                            <el-radio-button label="1">解决</el-radio-button>
                                            <el-radio-button label="2">未解决</el-radio-button>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div>
                                    <el-input v-model="activeRenew.conclusion.conclusion_remark"
                                              type="textarea"
                                              :rows="2"
                                              @blur="handleRealTimeSave"
                                              placeholder="请输入本次续班总结">
                                    </el-input>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="recommendRenew in $parentInfo.renewDetail.recommendRenew" v-if="$parentInfo.renewDetail.recommendSubjects[recommendRenew.subject_id].view==1">
                        <td style="width: 100px"  >{{recommendRenew.subject_name}}</td>
                        <td >
                            <div style="display: flex;flex-direction: row;justify-content:space-around ">
                                <div>
                                    <el-input v-model="recommendRenew.recommend_reason"
                                              type="textarea"
                                              :rows="2"
                                              @blur="handleRealTimeSave"
                                              placeholder="请输入推荐理由">
                                    </el-input>
                                </div>
                                <div>
                                    <el-input v-model="recommendRenew.recommend_teacher"
                                              @blur="handleRealTimeSave"
                                              placeholder="请输入老师">
                                    </el-input>
                                </div>
                            </div>
                        </td>
                        <td colspan="2">
                            <div>
                                <el-radio-group v-model="recommendRenew.apply_id" @change="handleRealTimeSave()">
                                    <el-radio-button label="1">报名</el-radio-button>
                                    <el-radio-button label="2">不报名</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div v-if="recommendRenew.apply_id==2">
                                <el-input v-model="recommendRenew.no_apply_reason"
                                          type="textarea"
                                          :rows="2"
                                          @blur="handleRealTimeSave"
                                          placeholder="请输入不报名原因">
                                </el-input>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </vue-scroll>
        <div style="text-align: right">
            <el-button type="primary" @click="handleSave()">结束回访</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Second_RenewDetail",
        data() {
            return {
                task_ids:[],
                remark:'',
                status_array:[
                    {
                        'id':'active',
                        'name':'未开始'
                    },
                    {
                        'id':'hesitate',
                        'name':'犹豫'
                    },
                    {
                        'id':'appoint',
                        'name':'预约'
                    },
                    {
                        'id':'clearIntention',
                        'name':'已明确意向'
                    },
                    {
                        'id':'rushFee',
                        'name':'催费'
                    },
                    {
                        'id':'reject',
                        'name':'拒绝'
                    },
                ],
                notContinueClassReasons:[
                    {
                        id:1,
                        name:'没效果',
                        remark:'不读书具体体现及其他描述',
                        remark2:'课程、老师，具体何处不满意，有什么需求'
                    },
                    {
                        id:2,
                        name:'学生不想补',
                        remark:''
                    },
                    {
                        id:3,
                        name:'换地方排',
                        remark:'去了哪里，那边怎么样，与墨帝比如何，劝试听，建议确认清楚哪边更好'
                    },
                    {
                        id:4,
                        name:'没时间',
                        remark:'具体哪些事情时间占用，对应耗时是否合理'
                    },
                    {
                        id:5,
                        name:'墨帝换老师',
                        remark:'是否原因试听新老师，不愿意的理由'
                    },
                    {
                        id:6,
                        name:'距离太远',
                        remark:''
                    },
                    {
                        id:7,
                        name:'不想上网课',
                        remark:'是否告知暑假预计开放线下，家长反馈'
                    },
                    {
                        id:8,
                        name:'报了其他学科，时间占用，无操作',
                        remark:''
                    },
                    {
                        id:9,
                        name:'其他',
                        remark:''
                    },

                ],
                continueClass_otherReason:[
                    {
                        id:1,
                        name:'休息一下',
                        remark:'分析休息合理性，成绩，年级特点，同学已报名'
                    },
                    {
                        id:2,
                        name:'同学一起',
                        remark:'去了哪里，那边怎么样，与墨帝比如何，劝试听建议确认清楚哪边更好'
                    },
                    {
                        id:3,
                        name:'其他',
                        remark:''
                    },
                ],
                subsequent_choose:[
                    {
                        id:1,
                        name:'教研约谈'
                    },
                    {
                        id:2,
                        name:'预约试听'
                    },
                    {
                        id:3,
                        name:'老师辅助'
                    },
                    {
                        id:4,
                        name:'电话说服'
                    },
                    {
                        id:5,
                        name:'其他'
                    },
                ],
                tasks:[
                    {
                        id:1,
                        name:'转发商城'
                    },
                    {
                        id:2,
                        name:'企业微信'
                    },
                    {
                        id:3,
                        name:'qq'
                    },
                    {
                        id:4,
                        name:'公众号关注'
                    },
                    {
                        id:5,
                        name:'请假说明'
                    },
                ],

                template_recommendRenew:{
                    subject_id: '',
                    subject_name: '',
                    recommend_reason:'',
                    recommend_teacher:'',
                    apply_id:'',
                    no_apply_reason:''
                },
                template_activeRenew:{
                    subject_id: '',
                    subject_name: '',
                    attitude: {
                        id: '',
                        remark: ''
                    },
                    continueClass: {
                        id: '',
                        cancelReason_id: 1,
                        otherReason_id: 1,
                        remark: '',
                        remark2: ''
                    },
                    conclusion: {
                        subsequent_id:[],
                        resolve_id:'',
                        conclusion_remark:''
                    }
                }
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleDetail();
        },
        computed: {
            keyNotContinueClassReasons: function () {
                return this._.keyBy(this.notContinueClassReasons, 'id');
            },
            keyContinueClass_otherReason: function () {
                return this._.keyBy(this.continueClass_otherReason, 'id');
            },
        },
        methods: {
            handleDetail(){
                this.$parentInfo.renewDetail_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'get_new_renew_detail', {
                    'student_id': this.$parentInfo.choose_student_id,
                    'template_activeRenew':this.template_activeRenew
                })
            },
            handleActive(subject_id,type_id){
                if(type_id==1){
                    this.$parentInfo.renewDetail.activeSubjects[subject_id].view=1
                }else{
                    this.$parentInfo.renewDetail.activeSubjects[subject_id].view=0
                }
                this.handleRealTimeSave()
            },
            handleRecommend(subject_id){
                if(this.$parentInfo.renewDetail.recommendSubjects[subject_id]){
                    if(this.$parentInfo.renewDetail.recommendSubjects[subject_id].view==1){
                        this.$parentInfo.renewDetail.recommendSubjects[subject_id].view=0
                    }else{
                        this.$parentInfo.renewDetail.recommendSubjects[subject_id].view=1
                        let template_recommendRenew={
                                subject_id: subject_id,
                                subject_name: this.$parentInfo.renewDetail.recommendSubjects[subject_id].name,
                                recommend_reason:'',
                                recommend_teacher:'',
                                apply_id:'',
                                no_apply_reason:''
                        };

                        if(!this.$parentInfo.renewDetail.recommendRenew[subject_id]){
                            this.$set(this.$parentInfo.renewDetail.recommendRenew,subject_id,template_recommendRenew)
                        }
                    }
                }
                this.handleRealTimeSave()
            },
            handleSave(){
               // this.$parentInfo.renewDetail.task_ids=this.task_ids;
                if(this.$parentInfo.renewDetail.task_ids.length<5){
                    this.$message({
                        message: '完成所有任务后方可结束回访',
                        type: 'warning'
                    });
                }else{
                    this.$wApi.send(this.$parentInfo.path, 'update_new_student_renew_time', {
                        'renewDetail': this.$parentInfo.renewDetail,
                        'status':'finished'
                    })
                }
            },
            handleRealTimeSave(){
                //this.$parentInfo.renewDetail.task_ids=this.task_ids;
                this.$wApi.send(this.$parentInfo.path, 'update_new_student_renew_time', {
                    'renewDetail': this.$parentInfo.renewDetail,
                    'status':'active'
                })
            },
            handleStudentDetail(){
                this.$parentInfo.drawer=false
                this.$store.dispatch('addView', {
                    'title':  this.$parentInfo.title,
                    'path': '/student/' + this.$parentInfo.renewDetail.student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + this.$parentInfo.renewDetail.student_id})
            }
        }
    }
</script>

<style scoped>

</style>